
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-dff4e170&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WorksManagement.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WorksManagement.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-dff4e170!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WorksManagement.vue"),
  /* scopeId */
  "data-v-dff4e170",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/center/WorksManagement.vue
// module id = 567
// module chunks = 0